import { Tip } from 'Interfaces/TipInterface';
import React, { useEffect, useState } from 'react';
import './styles.sass'

export enum InputType {
    'radio' = 'radio',
    'checkbox' = 'checkbox',
};

export interface OptionType {
    label: string;
    value: string;
};

export interface Props {
    isDisabled: boolean;
    text: string;
    onClick: () => void;
    tooltips?: Tip[]; 
    submissionInProgress: boolean;
};

/**
 * TODO: Describe this component!
 */
const MvPrimaryBtn = ({
    isDisabled,
    text,
    onClick,
    tooltips,
    submissionInProgress,
}: Props) => {

    const classNames = ['mv-primary-btn'];

    if (submissionInProgress) {
        classNames.push('pending-submission')
    }

    return (
        <span className={classNames.join(' ')}>
            <input
                type='button'
                value={text}
                onClick={onClick}
                disabled={isDisabled}
            />
        </span>
    );
};

export {
    MvPrimaryBtn,
};
